import { EventType } from 'lib/EventSchema';
import { EventData } from 'lib/EventLogger/Event';

export default function SessionStartedEvent(): EventData {
  // eslint-disable-next-line camelcase
  return {
    event_type: EventType.sessionStarted,
    event_context: {
      user_agent:
        typeof window !== 'undefined' && window.navigator ? window.navigator.userAgent : '',
    },
  };
}
